import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//import styles
import style from "./a.module.scss";
//import components
import BackButton from "../../components/BackButton/BackButton";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../components/SecondaryButton/SecondaryButton";
import TextBox from "../../components/TextBox/TextBox";
import SliderButton from "../../components/SliderButton/SliderButton.tsx";
//import assets
import crossIcon from "../../assets/icons/cross.svg";
import nameIcon from "../../assets/icons/profile.svg";
import collegeIcon from "../../assets/icons/mdi_college-outline.svg";
import branchIcon from "../../assets/icons/branch.svg";
import batchIcon from "../../assets/icons/uiw_date.svg";
import linkedinIcon from "../../assets/icons/mdi_linkedin.svg";
import githubIcon from "../../assets/icons/mdi_github.svg";
import searchSkillsIcon from "../../assets/icons/bi_wrench-adjustable-circle-fill.svg";
import whyMentorIcon from "../../assets/icons/mdi_head-question.svg";
import phoneIcon from "../../assets/icons/phone.svg";
import passwordIcon from "../../assets/icons/mdi_password.svg";
import confirmPasswordIcon from "../../assets/icons/mdi_password-1.svg";
import otpIcon from "../../assets/icons/otp.svg";
import emailIcon from "../../assets/icons/material-symbols_mail.svg";
import chooseMentor from "../../assets/Illustrations/choose-mentor.svg"
import registerMentor from "./context";


const SignUp = () => {
  const navigate = useNavigate();
  const [isMentor, setIsMentor] = useState(true);
  const collegeOptions = ['DY Patil college of engineering','IIT Bombay']
  const branchOptions = ['Computer science', 'Information technology', 'Artificial Intelligence and Data Science', 'Mechanical', 'Civil']
  const batchOptions = ['2018 - 2022', '2019 - 2023', '2020 - 2024', '2021 - 2025', '2022 - 2026']
  const skills =['C++' , 'Java' , 'Python' , 'Java-Script' , 'Next-JS', 'React-JS' , 'Node-JS' , 'Express-JS' , 'ThreeJS' , 'Bootstrap' , 'Github' , 'Netlify' , 'Vercel' , 'Notion' , 'Figma' , 'Canva' , 'Firebase' ,
    'MongoDB' , 'VR' , 'Ionic' , 'Amazon Web Server (AWS)' , 'Microsoft Azure' , 'Git' , 'Unity' , 'Unreal' , 'Blender']
  const MentorHeadline = () => {
    return (
      <h1>
        Become an important<br></br> part of community
      </h1>
    );
  };
  const MenteeHeadline = () => {
    return (
      <h1>
        Become an important<br></br> clog for this clock
      </h1>
    );
  };

  const Form = () => {
    const [formData, setFormData] = useState({
        name:'',
        college:'',
        branch:'',
        batch:'',
        linkedin:'',
        github:'',
        skills:[],
        whyYouWantToBecomeMentor:'',
        phoneNumber:'',
        email:'',
        password:''
    });
    const [confirmPassword,setConfirmPassword] = useState('')
    const [otp,setOtp] = useState()
    const [searchSkills, setSearchSkills] = useState('');

    const addSkills = (e) =>{
        const skills = formData.skills
        if(!formData.skills.includes(e)){
            skills.push(e)
        }
        setFormData({ ...formData,skills:skills})
        setSearchSkills('')
    }

    const removeSkills = (e) => {
        const skills = formData.skills
        var remainingSkills = skills.filter(skill => {
            if(skill != e){
                return skill;
            }
        })
        setFormData({ ...formData,skills:remainingSkills})
    }
    var filteredValue=skills.filter((skill) =>{
        if(skill.toLowerCase().includes(searchSkills.toLowerCase())){
            return skill
        }
    })

    const handleSubmit = async (e) => {
        console.log(formData)
        const mentorRegisterResponse = await registerMentor(formData)
        console.log(mentorRegisterResponse)
    }
    
    return (
      <div className={style.form}>
        <TextBox type="name" placeholder="Name" icon={nameIcon} value={formData.name} onChange={(e) => setFormData({...formData,name:e.target.value})} inputBox={true}/>
        <TextBox type="text" placeholder="College" icon={collegeIcon} value={formData.college} onChange={(e) => setFormData({ ...formData,college:e.target.value})} dropDown={true} options={collegeOptions}/>
        <TextBox type="text" placeholder="Branch" icon={branchIcon} value={formData.branch} onChange={(e) => setFormData({ ...formData,branch:e.target.value})} dropDown={true} options={branchOptions}/>
        <TextBox type="text" placeholder="Batch" icon={batchIcon} value={formData.batch} onChange={(e) => setFormData({ ...formData,batch:e.target.value})} dropDown={true} options={batchOptions}/>
        <TextBox type="link" placeholder="Linkedin Profile url" icon={linkedinIcon} value={formData.linkedin} onChange={(e) => setFormData({...formData,linkedin:e.target.value})} inputBox={true}/>
        <TextBox type="text" placeholder="Github Profile url" icon={githubIcon} value={formData.github} onChange={(e) => setFormData({...formData,github:e.target.value})} inputBox={true}/>
        {
            formData.skills.length>0 ?
            <div className={style.skillsBox}>
            {formData.skills.map(skill => {
                return (
                    <div onClick={()=>removeSkills(skill)}>
                        <h1>{skill}</h1>
                        <img src={crossIcon} alt="cross button"></img>
                    </div>
                )
            })}
            </div>:null
        }
        <TextBox type="text" placeholder="Add skills" icon={searchSkillsIcon} value={formData.searchSkills} onChange={(e) => setSearchSkills(e.target.value)} inputBox={true}/>
        {
            searchSkills ?
                <div className={style.searchSkills}>
                    {filteredValue.length>0?
                        (filteredValue.map((skill,i)=>{
                            if(i<5){
                                return <div className={style.options}><p onClick={()=>addSkills(skill)}>{skill}</p></div>
                            }
                        }))
                        :
                        <div><p className={style.noSkills}>No skills found</p></div>}
                </div>
            :null
        }
        <TextBox type="text" placeholder="Why you want to become mentor" icon={whyMentorIcon} value={formData.whyYouWantToBecomeMentor} onChange={(e) => setFormData({...formData,whyYouWantToBecomeMentor:e.target.value})} textArea={true}/>
        <TextBox type="number" placeholder="Phone Number" icon={phoneIcon} value={formData.phoneNumber} onChange={(e) => setFormData({...formData,phoneNumber:e.target.value})} inputBox={true}/>
        <TextBox type="email" placeholder="Email" icon={emailIcon} value={formData.email} onChange={(e) => setFormData({...formData,email:e.target.value})} inputBox={true}/>
        <TextBox type="password" placeholder="Password" icon={passwordIcon} value={formData.password} onChange={(e) => setFormData({...formData,password:e.target.value})} inputBox={true}/>
        <TextBox type="password" placeholder="Confirm password" icon={confirmPasswordIcon} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} inputBox={true}/>
        <div className={style.sendOTP}>
            <PrimaryButton title="Send OTP"/>
        </div>
        <TextBox type="number" placeholder="Enter OTP" icon={otpIcon} value={otp} onChange={(e) => setOtp(e.target.value)} inputBox={true}/>
        <div className={style.sendOTP} onClick={handleSubmit}>
            <PrimaryButton title="Submit" />
        </div>
      </div>
    );
  };


  const FormSection = () => {
    return (
      <div className={style.formSection}>
        <div className={style.backButton} onClick={() => navigate(-1)}>
          <BackButton />
        </div>
        <div className={style.formLayout}>
          {isMentor ? <MentorHeadline /> : <MenteeHeadline />}
          <div className={style.chooseOption}>
            <div className={style.options} onClick={() => setIsMentor(true)}>
              <div className={style.circles}>
                <div className={isMentor ? style.selected : ""}></div>
              </div>
              Mentor
            </div>
            <div className={style.options} onClick={() => setIsMentor(false)}>
              <div className={style.circles}>
                <div className={isMentor ? "" : style.selected}></div>
              </div>
              Mentee
            </div>
          </div>
          <div className={style.disclaimer}>
            {isMentor
              ? "All fields are mandatory"
              : "Fields with * fields are mandatory"}
          </div>
          <Form />
        </div>
      </div>
    );
  };

  const DetailSection = () => {
    return <div className={style.detailSection}>
      <div className={style.chooseMentorFeatures}>
        <div className={style.signInButton} onClick={() => navigate(-1)}>
          <SecondaryButton title="Sign In" />
        </div>
        <img src={chooseMentor} alt="Choose your mentor " />
        <p>Get in touch with your right mentor</p>
      </div>
      <div>
        <SliderButton leftSliderButton={true} rightSliderButton={true} />
      </div>
    </div>;
  };

  return (
    <div className={style.signUp}>
      <FormSection />
      <DetailSection />
    </div>
  );
};

export default SignUp;
